import { useEffect, useState } from "react";
import _ from "lodash";
import { useAtom } from "jotai";
import "./verify-account.css";
import axios from "../axios";
import { NavLink, useNavigate } from "react-router-dom";
import { logEvent } from "../analytics";
import { EVENTS } from "../constants/ga-constants";
import { alertData } from "./../states/alert";
import FeedbackPopup from "./feedback";

export default function VerifyAccount() {
  const [inProcess, setInProcess] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [Form, setForm] = useState([]);
  const [showId1, setShowId1] = useState("");
  const [loading, setLoading] = useState(true);
  const [showId2, setShowId2] = useState("");
  const [activePayNow, setActivePayNow] = useState(false);
  const navigation = useNavigate();
  const [state, setState] = useState({});
  // In your parent component (e.g. step2 form)
  const [selectedPlan, setSelectedPlan] = useState("");
  const [razorPayPlan, setRazorPayPlan] = useState(null);
  const [alert, setAlert] = useAtom(alertData);
  const [showFeedbackPopup, setShowFeedbackPopup] = useState(false);
  const [tutorDocStatusResponse, setTutorDocStatusResponse] = useState(null);
  const [subscriptionId, setSubscriptionId] = useState(null);
  const [userId, setUserId] = useState(null);
  const [isPaymentProcessing, setIsPaymentProcessing] = useState(false);

  const handleFeedbackSubmit = (data) => {
    console.log("User feedback:", data);
    axios
      .post("/v1/feedback", {
        ...data,
      })
      .then((response) => {
        console.log("🚀 ~ handleFeedbackSubmit ~ response.data:", response.data);
      })
      .catch((err) => {
        console.error("Error submitting feedback:", err);
      });
  };

  const handleNeedHelpSubmit = (data) => {
    axios
      .post("/v1/need-help", {
        ...data,
      })
      .then((response) => {
        console.log("🚀 ~ handleNeedHelpSubmit ~ response:", response.data);
      })
      .catch((err) => {
        console.error("Error submitting feedback:", err);
      });
  };

  const uploadAdhaarDoc = (e) => {
    try {
      const uploadedFile = e.target.files[0];
      if (
        !".pdf, .doc, .docx, .txt, .ppt, .jpg, .jpeg, .png, .gif".includes(uploadedFile.name.split(".").slice(-1)[0])
      ) {
        alert("only .pdf, .doc, .docx, .txt, .ppt, .jpg, .jpeg, .png, .gif format files are allowed");
        return;
      }
      if (uploadedFile && uploadedFile.size <= 10 * 1024 * 1024) {
        const { adhaar, id_card, is_paid, advance_amount, is_approved } = {
          ...state,
        };
        updateForm(adhaar, id_card, is_paid, advance_amount, is_approved, true, false);
        const formData = new FormData();
        formData.append("myImage", uploadedFile);
        axios
          .post(`v1/tutor/tutor-doc-upload`, formData, {
            headers: {
              "content-type": "multipart/form-data",
              "doc-type": "adhaar",
            },
          })
          .then((res) => {
            getVerificationStatusData();
            logEvent(EVENTS.DOC_UPLOAD.event_name);
          })
          .catch((err) => {
            getVerificationStatusData();
            alert("Failed to Upload Document");
          });
      } else {
        alert("Document size should be <= 10 MB");
      }
    } catch (error) {
      alert("Failed to Upload Document");
    }
  };

  const uploadIdDoc = (e) => {
    try {
      const uploadedFile = e.target.files[0];
      if (
        !".pdf, .doc, .docx, .txt, .ppt, .jpg, .jpeg, .png, .gif".includes(uploadedFile.name.split(".").slice(-1)[0])
      ) {
        alert("only .pdf, .doc, .docx, .txt, .ppt, .jpg, .jpeg, .png, .gif format files are allowed");
        return;
      }
      if (uploadedFile && uploadedFile.size <= 10 * 1024 * 1024) {
        const { adhaar, id_card, is_paid, advance_amount, is_approved } = {
          ...state,
        };
        updateForm(adhaar, id_card, is_paid, advance_amount, is_approved, false, true);
        const formData = new FormData();
        formData.append("myImage", uploadedFile);
        axios
          .post(`v1/tutor/tutor-doc-upload`, formData, {
            headers: {
              "content-type": "multipart/form-data",
              "doc-type": "id_card",
            },
          })
          .then((res) => {
            getVerificationStatusData();
            logEvent(EVENTS.DOC_UPLOAD.event_name);
          })
          .catch((err) => {
            getVerificationStatusData();
            alert("Failed to Upload Document");
          });
      } else {
        alert("Document size should be <= 10 MB");
      }
    } catch (error) {
      alert("Failed to Upload Document");
    }
  };

  const onInputClick = (event) => {
    event.target.value = null;
  };

  const updateForm = (adhaar, id_card, is_paid, advance_amount, is_approved, loadingId1, loadingId2) => {
    setForm([
      {
        icon: "./verification-process-step1-icon.svg",
        title: "Upload Document",
        viewed: true,
        filled: adhaar || id_card,
        fields: [
          {
            show: true,
            name: "step 0",
            input: (
              <div className="step1-form-wrapper">
                <div className="step1-form-desc">
                  Upload any one of your Government ID Proof{" "}
                  <span className="yellow-color">
                    {" "}
                    (eg . Adhar Card / Voter Id card / PAN card / Passport / Driving license){" "}
                  </span>{" "}
                  and submit it to our portal.
                  <br /> Only authenticated verified tutors are enlisted and given opportune tuition's at Home Shiksha.
                </div>

                {!adhaar ? (
                  <form className="step1-form-input-wrapper">
                    <div className="step1-form-input-title">ID Proof-1</div>
                    <label htmlFor="adhaar-1">
                      <div className="step1-form-input-upload">
                        {loadingId1 ? (
                          "Uploading"
                        ) : (
                          <>
                            <img src="./paperclip-icon.svg" alt="paperclip-icon" />
                            Upload
                          </>
                        )}
                      </div>
                    </label>
                    <input
                      id="adhaar-1"
                      type="file"
                      name="myImage"
                      accept=".pdf, .doc, .docx, .txt, .ppt, .jpg, .jpeg, .png, .gif"
                      onClick={onInputClick}
                      onChange={uploadAdhaarDoc}
                      style={{ display: "none" }}
                    />
                  </form>
                ) : (
                  <form className="step1-form-input-wrapper">
                    <div className="step1-form-input-title">ID Proof-1</div>
                    <label htmlFor="adhaar-1">
                      <div className="step1-form-input-update">
                        {loadingId1 ? (
                          "Uploading"
                        ) : (
                          <>
                            <img src="./paperclip-icon.svg" alt="paperclip-icon" />
                            Update
                          </>
                        )}
                      </div>
                    </label>
                    {!loadingId1 && (
                      <span
                        className="step1-form-input-upload"
                        onClick={() => {
                          setShowId1(adhaar);
                        }}
                      >
                        View
                      </span>
                    )}

                    <input
                      id="adhaar-1"
                      type="file"
                      name="myImage"
                      accept=".pdf, .doc, .docx, .txt, .ppt, .jpg, .jpeg, .png, .gif"
                      onClick={onInputClick}
                      onChange={uploadAdhaarDoc}
                      style={{ display: "none" }}
                    />
                  </form>
                )}
                {!id_card ? (
                  <form className="step1-form-input-wrapper">
                    <div className="step1-form-input-title">ID Proof-2</div>
                    <label htmlFor="id-card-1">
                      <div className="step1-form-input-upload">
                        {loadingId2 ? (
                          "Uploading"
                        ) : (
                          <>
                            <img src="./paperclip-icon.svg" alt="paperclip-icon" />
                            Upload
                          </>
                        )}
                      </div>
                    </label>
                    <input
                      id="id-card-1"
                      type="file"
                      name="myImage"
                      accept=".pdf, .doc, .docx, .txt, .ppt, .jpg, .jpeg, .png, .gif"
                      onClick={onInputClick}
                      onChange={uploadIdDoc}
                      style={{ display: "none" }}
                    />
                  </form>
                ) : (
                  <form className="step1-form-input-wrapper">
                    <div className="step1-form-input-title">ID Proof-2</div>
                    <label htmlFor="id-card-1">
                      <div className="step1-form-input-update">
                        {loadingId2 ? (
                          "Uploading"
                        ) : (
                          <>
                            <img src="./paperclip-icon.svg" alt="paperclip-icon" />
                            Update
                          </>
                        )}
                      </div>
                    </label>
                    {!loadingId2 && (
                      <span
                        className="step1-form-input-upload"
                        onClick={() => {
                          setShowId2(id_card);
                        }}
                      >
                        View
                      </span>
                    )}

                    <input
                      id="id-card-1"
                      type="file"
                      name="myImage"
                      accept=".pdf, .doc, .docx, .txt, .ppt, .jpg, .jpeg, .png, .gif"
                      onClick={onInputClick}
                      onChange={uploadIdDoc}
                      style={{ display: "none" }}
                    />
                  </form>
                )}

                <div
                  className="step1-form-desc"
                  style={{
                    textAlign: "left",
                    backgroundColor: "rgba(255, 248, 232, 1)",
                    borderRadius: "8px",
                  }}
                >
                  <div className="secure-note-wrapper">
                    <div className="secure-title">
                      <span>100% Secure{"  "}</span>
                      <img src="./payment-security-icon.svg" alt="secure icon" className="secure-icon" />
                    </div>

                    <ul className="secure-points">
                      <li>Your documents are for verification by the HomeShiksha team only.</li>
                      <li>We ensure your data is safe and secure.</li>
                      <li>Your information will never be shared with others.</li>
                    </ul>
                  </div>
                </div>
              </div>
            ),
            completed: false,
            errorMsg: "",
          },
        ],
      },
      {
        icon: "./verification-process-step2-icon.svg",
        title: "Submission Of Verification Fee",
        viewed: adhaar || id_card,
        filled: is_paid,
        fields: [
          {
            show: !is_paid,
            name: " step 1",
            input: (
              <div className="step2-form-wrapper">
                {/* <div className="step2-form-payment-img-wrapper">
                  <img src="./payment-icon.svg" alt="payment-icon" />
                </div>
                {!activePayNow ? (
                  <div
                    className="step2-form-paynow-btn"
                    onClick={() => {
                      setActivePayNow(true);
                      payNow();
                    }}
                  >
                    Pay now
                  </div>
                ) : (
                  <div
                    className="step2-form-paynow-btn"
                    onClick={() => {
                      setActivePayNow(false);
                    }}
                  >
                    Reload
                  </div>
                )}
                <div className="step2-form-payment-title-amount">Subscription Fee {advance_amount}/-</div> */}

                <div className="money-back-banner">
                  <img src="./money-back-img.png" alt="Money Back Guarantee" className="money-back-badge" />
                  <div className="money-back-text-container">
                    <div className="money-back-title">MONEY BACK GUARANTEE</div>
                    <div className="money-back-subtitle">Complete money will be refunded if you dont get any tuition within 90 days</div>
                  </div>
                </div>

                <div className="select-plan-title">Select your plan</div>

                <div className="plan-selection-container">
                  <div className={`plan-box ${selectedPlan === "tu-pl-499" ? "selected-plan" : ""}`}>
                    <div className="lto-ribbon">Limited<br />Time<br />Offer</div>
                    <div className="plan-label-wrapper">
                      <div className="plan-label basic-label">Basic Plan</div>
                    </div>
                    <div className="plan-price">
                      <span className="price-currency">₹</span>
                      <span className="price-amount">499</span>
                      <span className="price-suffix">/-</span>
                    </div>
                    <div className="plan-gst">* Exclusive of GST.</div>
                    <ul className="plan-features">
                      <li className="check">MoneyBack Guarantee (if you don't get any tuition's matching your profile within 2 months)</li>
                      <li className="check">Get multiple high paying tuition opportunities on daily basis.</li>
                      <li className="check">Subscription Validity: 12 months</li>
                      <li className="check">Receive daily Whatsapp &amp; In App notifications</li>
                      <li className="cross">High paying opportunities from VIP/VVIP clients</li>
                      <li className="cross">Get Experience certificate</li>
                      <li className="cross">Rank higher among other tutors.</li>
                      <li className="cross">Get recommendation letter when ever needed.</li>
                    </ul>
                    <button
                      className="plan-btn"
                      onClick={() => {
                        setSelectedPlan("tu-pl-499");
                        setRazorPayPlan("tu-pl-499");
                      }}
                    >
                      {selectedPlan === "tu-pl-499" ? "Selected" : "Choose Plan"}
                    </button>
                  </div>

                  <div className={`plan-box ${selectedPlan === "tu-pl-999" ? "selected-plan premium-border" : "premium-border"}`}>
                    <div className="lto-ribbon">Limited<br />Time<br />Offer</div>
                    <div className="plan-label-wrapper">
                      <div className="plan-label premium-label">Premium Plan</div>
                    </div>
                    <div className="plan-price">
                      <span className="price-currency">₹</span>
                      <span className="price-amount">999</span>
                      <span className="price-suffix">/-</span>
                    </div>
                    <div className="plan-gst">* Exclusive of GST.</div>
                    <ul className="plan-features">
                      <li className="check">MoneyBack Guarantee (if you don't get any tuition's matching your profile within 2 months)</li>
                      <li className="check">Get multiple high paying tuition opportunities on daily basis.</li>
                      <li className="check">Subscription Validity: Life time</li>
                      <li className="check">Receive daily Whatsapp &amp; In App notifications</li>
                      <li className="check">Get high paying opportunites from VIP/VVIP clients</li>
                      <li className="check">Get Experience certificate after 6 months</li>
                      <li className="check">Rank higher among other tutors.</li>
                      <li className="check">Get recommendation letter when ever needed.</li>
                    </ul>
                    <button
                      className="plan-btn"
                      onClick={() => {
                        setSelectedPlan("tu-pl-999");
                      }}
                    >
                      {selectedPlan === "tu-pl-999" ? "Selected" : "Choose Plan"}
                    </button>
                  </div>
                </div>
              </div>
            ),
            completed: false,
            errorMsg: "",
          },
          {
            show: is_paid,
            name: "",
            input: (
              <div className="step2-form-wrapper">
                <div className="step2-form-payment-img-wrapper">
                  <img src="./green-tic-icon.svg" alt="green-tic-icon" />
                </div>
                <div className="step2-form-paymentCompleted-desc">Payment Done</div>
                <br />
                <div className="step2-form-payment-desc">
                  Congratulations. Welcome to <span className="yellow-color"> HomeShiksha </span> Family!
                  <br />
                  <br />
                  Your respective city <span className="yellow-color"> CRE </span> will get in touch with you{" "}
                  <span className="yellow-color"> shortly </span>.
                </div>
              </div>
            ),
            completed: false,
            errorMsg: "",
          },
        ],
      },
      {
        icon: "./verification-process-step3-icon.svg",
        title: "Get Set to Earn. Choose tuitions as per your flexibility.",
        viewed: is_paid,
        filled: false,
        fields: [
          {
            show: true,
            name: "",
            input: (
              <div className="step3-form-wrapper">
                <div>
                  <img src="./verification-process-step3-icon.svg" alt="verification-process-step3-icon" />
                </div>
                <div className="step2-form-paynow-btn">
                  <NavLink
                    onClick={() => {
                      navigation("/dashboard");
                      window.location.reload();
                    }}
                  >
                    <span style={{ color: "white" }}>Explore</span>
                  </NavLink>
                </div>
                <div className="step2-form-payment-desc">
                  CRE will assign you for <span className="yellow-color"> demo classes </span>, you will be notified.
                  <br />
                  <br />
                  Make sure <span className="yellow-color"> accept </span> the invitation.Check out dashboard for
                  available requirements which <span className="yellow-color"> matches </span> your profile !
                </div>
              </div>
            ),
            completed: false,
            errorMsg: "",
          },
        ],
      },
    ]);
  };

  const getVerificationStatusData = () => {
    if (tutorDocStatusResponse) {
      const { adhaar, id_card, is_paid, advance_amount: amount, is_approved, plans } = tutorDocStatusResponse.status;

      const advance_amount = selectedPlan ? _.find(plans, (plan) => plan.plan_id === selectedPlan)?.amount : amount;

      updateForm(adhaar, id_card, is_paid, advance_amount, is_approved, false, false);
      setState({ adhaar, id_card, is_paid, advance_amount, is_approved });
      setLoading(false);
    } else {
      axios
        .post(`v1/tutor/tutor-doc-status`)
        .then((res) => {
          setTutorDocStatusResponse(res.data);

          const { adhaar, id_card, is_paid, advance_amount: amount, is_approved, plans } = res.data.status;

          const advance_amount = selectedPlan ? _.find(plans, (plan) => plan.plan_id === selectedPlan)?.amount : amount;

          updateForm(adhaar, id_card, is_paid, advance_amount, is_approved, false, false);
          setState({ adhaar, id_card, is_paid, advance_amount, is_approved });
          setLoading(false);
        })
        .catch((err) => {
          setLoading(true);
        });
    }
  };

  useEffect(() => {
    const beforeUnloadHandler = (e) => {
      if (inProcess && !isPaymentProcessing) {
        e.preventDefault();
        e.returnValue = "";
        setShowFeedbackPopup(true);
        return "";
      }
    };

    window.addEventListener("beforeunload", beforeUnloadHandler);
    return () => window.removeEventListener("beforeunload", beforeUnloadHandler);
  }, [currentStep, selectedPlan, state, isPaymentProcessing]);

  useEffect(() => {
    getVerificationStatusData();
  }, [activePayNow, selectedPlan]);

  useEffect(() => {
    if (subscriptionId) {
      const openPopUp = () => {
        // Check if Razorpay is loaded
        if (typeof window.Razorpay === "undefined") {
          console.error("Razorpay SDK not loaded");
          setAlert({
            show: true,
            message: "Payment system is not available. Please refresh the page and try again.",
            type: "error",
          });
          return;
        }

        // Check if Razorpay key is configured
        if (!process.env.REACT_APP_RAZORPAY_KEY_ID) {
          console.error("Razorpay key not configured");
          setAlert({
            show: true,
            message: "Payment configuration error. Please contact support.",
            type: "error",
          });
          return;
        }

        const options = {
          key: process.env.REACT_APP_RAZORPAY_KEY_ID,
          name: "HomeShiksha",
          description: "Access to HomeShiksha",
          image: "./profile.jpg",
          subscription_id: subscriptionId,
          callback_url: `${process.env.REACT_APP_DOMAIN_NAME}v1/subscriptions?isTutor=true`,
          prefill: {
            name: "HomeShiksha",
            email: "homeshiksha@gmail.com",
            contact: "9876543210",
          },
          notes: {
            address: "HomeShiksha",
          },
          theme: {
            color: "#2B93A5",
          },
        };

        const razor = new window.Razorpay(options);
        razor.open();
      };
      openPopUp();
    }
  }, [subscriptionId, userId]);

  const payNow = async () => {
    setIsPaymentProcessing(true);
    if (selectedPlan === "tu-pl-999") {
      try {
        // Step 1: Create order from backend
        const {
          data: { data: order },
        } = await axios.post("v1/tutor/create-order");

        const user = JSON.parse(localStorage.getItem("userDetails"));

        // Step 2: Configure Razorpay
        const options = {
          key: process.env.REACT_APP_RAZORPAY_KEY_ID,
          amount: order.amount,
          currency: order.currency,
          name: "HomeShiksha",
          description: "Lifetime Plan (₹999 + 18% GST)",
          order_id: order.id,
          callback_url: `${process.env.REACT_APP_DOMAIN_NAME}v1/tutor/order-payment-verification?userId=${user.id}`, // ✅ backend URL
          prefill: {
            name: user.name + user.l_name,
            email: user.email,
            contact: user.phone,
          },
          theme: {
            color: "#2B93A5",
          },
        };

        const rzp = new window.Razorpay(options);
        rzp.open();
      } catch (error) {
        debugger;
        setIsPaymentProcessing(false);
        setLoading(false);
        console.error("Payment Error:", error);
      }
    } else {
      try {
        // Step 1: Create order from backend
        const {
          data: { data: order },
        } = await axios.post("v1/tutor/create-order", { planType: "Basic" });

        const user = JSON.parse(localStorage.getItem("userDetails"));
        debugger;
        // Step 2: Configure Razorpay
        const options = {
          key: process.env.REACT_APP_RAZORPAY_KEY_ID,
          amount: order.amount,
          currency: order.currency,
          name: "HomeShiksha",
          description: "Basic Plan (₹499 + 18% GST)",
          order_id: order.id,
          callback_url: `${process.env.REACT_APP_DOMAIN_NAME}v1/tutor/order-payment-verification?userId=${user.id}&planType=Basic`, // ✅ backend URL
          prefill: {
            name: user.name + user.l_name,
            email: user.email,
            contact: user.phone,
          },
          theme: {
            color: "#2B93A5",
          },
        };

        const rzp = new window.Razorpay(options);
        rzp.open();
      } catch (error) {
        debugger;
        setIsPaymentProcessing(false);
        setLoading(false);
        console.error("Payment Error:", error);
      }
      // try {
      //   const payload = {
      //     planId: "plan_RP22sEuAGzS1P3",
      //     userId: JSON.parse(localStorage.getItem("userDetails"))?.id,
      //     isTutor: true,
      //   };
      //   const { data } = await axios.post(`v1/plans`, payload);
      //   setSubscriptionId(data?.subscriptionId);
      // } catch (error) {
      //   setIsPaymentProcessing(false);
      //   setLoading(false);
      //   console.error(error);
      // }
    }

    // logEvent(EVENTS.PAY_NOW_BUTTON.event_name);
    // axios
    //   .post("/v1/subscribe-to-plan", { selectedPlan })
    //   .then((response) => {
    //     const requestData = response.data;
    //     if (requestData.data.includes("https:")) {
    //       setTimeout(() => {
    //         window.open(requestData.data, "_blank");
    //       });
    //     }
    //   })
    //   .catch((err) => {});
  };

  useEffect(() => {
    getVerificationStatusData();
    logEvent(EVENTS.VERIFY_NOW_BUTTON.event_name);
  }, []);

  return !loading ? (
    <main className="main verify-account">
      <dialog open={showId1} className="tc-dialog-box">
        <button
          className="tc-dialog-close-top"
          onClick={() => setShowId1("")}
          type="button"
          aria-label="Close"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
        {showId1 && ".jpg,.jpeg,.png,.gif,.mp4,.mov,.avi".includes(showId1.split(".").pop().toLowerCase()) ? (
          <img src={showId1} alt="Id Proof 1" width={"100%"} height={"100%"} />
        ) : (
          <>
            <a
              href={showId1}
              target="_blank"
              style={{
                display: "flex",
                justifyContent: "center",
                margin: "20px",
              }}
              rel="noopener noreferrer"
            >
              Download ID Proof 1
            </a>
          </>
        )}
        <button
          onClick={() => {
            setShowId1("");
          }}
          type="button"
        >
          Close
        </button>
      </dialog>
      <dialog open={showId2} className="tc-dialog-box">
        <button
          className="tc-dialog-close-top"
          onClick={() => setShowId2("")}
          type="button"
          aria-label="Close"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
        {showId2 && ".jpg,.jpeg,.png,.gif,.mp4,.mov,.avi".includes(showId2.split(".").pop().toLowerCase()) ? (
          <img src={showId2} alt="Id Proof 2" width={"100%"} height={"100%"} />
        ) : (
          <>
            <a
              href={showId2}
              target="_blank"
              style={{
                display: "flex",
                justifyContent: "center",
                margin: "20px",
              }}
              rel="noopener noreferrer"
            >
              Download ID Proof 2
            </a>
          </>
        )}
        <button
          onClick={() => {
            setShowId2("");
          }}
          type="button"
        >
          Close
        </button>
      </dialog>

      {inProcess ? (
        <div className="verification--wrapper">
          {!Form[Form.length - 1].viewed ? (
            <div className="verify-your-account-title">Verification Process</div>
          ) : (
            <div className="verify-your-account-title">You have been Verified</div>
          )}
          <div className="verification-steps-wrapper-container">
            <div className="verify-your-account-steps--wrapper">
              {Form.map((stepItem, stepIndex) => {
                return (
                  <div className="verify-your-account-step-container">
                    <div className="verify-your-account-step-icon--wrapper">
                      <img src={stepItem.icon} alt="profilePic" style={{ width: "100%" }} />
                    </div>
                    <div className="verify-your-account-step-count">Step {stepIndex + 1}</div>
                    {/* <div className='verify-your-account-step--step-desc'>{stepItem.title}</div> */}
                    <div
                      className={`verify-your-account-step-status--wrapper ${stepItem.viewed
                          ? "verify-your-account-step-status-color-border"
                          : "verify-your-account-step-status-blur-border"
                        } `}
                      onClick={() => {
                        if (Form[stepIndex].viewed) {
                          setCurrentStep(() => stepIndex);
                        }
                      }}
                    >
                      {!!stepItem.filled && <img src="./yellow-tic-icon.svg" alt="profilePic" />}
                    </div>
                    <div className="verify-your-account-step--step-desc">{stepItem.title}</div>
                  </div>
                );
              })}
            </div>
            <div className="verify-your-account-steps--overline"></div>
          </div>
          <div>
            {Form[currentStep].fields.map((field, index) => {
              if (field.show) return field.input;
              else return <div></div>;
            })}
          </div>

          <div className="forms-buttons--wrapper">
            {currentStep < Form.length - 1 && (
              <button
                type="button"
                className="forms-previous-btn"
                onClick={() => {
                  setSelectedPlan("");
                  if (inProcess) {
                    setShowFeedbackPopup(true);
                    return;
                  }

                  if (currentStep !== 0) {
                    setCurrentStep((pre) => pre - 1);
                  }
                  if (currentStep === 0) {
                    setInProcess(() => false);
                  }
                }}
              >
                Previous
              </button>
            )}
            {showFeedbackPopup && (
              <FeedbackPopup
                onClose={() => {
                  setShowFeedbackPopup(false);
                  setInProcess(() => false);
                }}
                onSubmit={handleNeedHelpSubmit}
                isPaymentFeedback={true}
              />
            )}
            {currentStep < Form.length - 1 && (
              <button
                type="button"
                className="forms-next-btn"
                style={{ backgroundColor: selectedPlan ? "#15a924" : "" }}
                onClick={() => {
                  if (selectedPlan) {
                    payNow();
                  } else if (Form[currentStep].filled) {
                    setForm((oldForm) => {
                      let newForm = [...oldForm];
                      // newForm[currentStep].filled=true
                      newForm[currentStep + 1].viewed = true;
                      return newForm;
                    });
                    setCurrentStep((pre) => pre + 1);
                  }
                }}
                disabled={isPaymentProcessing}
              >
                {selectedPlan ? (isPaymentProcessing ? "Processing..." : "Pay Now") : "Next"}
              </button>
            )}
          </div>
        </div>
      ) : (
        <div className="verification--wrapper">
          <div className="verify-your-account-title">Verify Your Account</div>
          <div className="verify-your-account-content--wrapper">
            <div className="verify-your-account-steps--wrapper">
              {Form.map((stepItem, stepIndex) => {
                return (
                  <div className="verify-your-account-step-container">
                    <div className="verify-your-account-step-icon--wrapper">
                      <img src={stepItem.icon} alt="profilePic" style={{ width: "100%" }} />
                    </div>
                    <div className="verify-your-account-step-count">Step {stepIndex + 1}</div>
                    <div className="verify-your-account-step--step-desc">{stepItem.title}</div>
                  </div>
                );
              })}
            </div>
            <div className="step2-form-payment-desc">
              Verify your <span className="yellow-color"> account </span> to get started with{" "}
              <span className="yellow-color"> classes </span>
            </div>
            <div
              className="forms-next-btn verify-your-account-btn-wrapper"
              onClick={() => {
                setInProcess(() => true);
                logEvent(EVENTS.VERIFY_NOW_BUTTON_2.event_name);
              }}
            >
              Verify Now
            </div>
          </div>
          <div className="reviews">
            <div>
              <div>
                <img src="./google-icon.svg" alt="profilePic" />
                <span style={{ color: "rgba(130, 130, 130, 1)", fontWeight: "600" }} className="reviewer-source-title">
                  {" "}
                  Google
                </span>
              </div>
              <div>
                <img src="./star-icon.svg" alt="star icon" className="star-icon" />
                <img src="./star-icon.svg" alt="star icon" className="star-icon" />
                <img src="./star-icon.svg" alt="star icon" className="star-icon" />
                <img src="./star-icon.svg" alt="star icon" className="star-icon" />
                <img src="./star-icon.svg" alt="star icon" className="star-icon" />
              </div>
              <div style={{ color: "rgba(130, 130, 130, 1)" }} className="review-content">
                Trusted Source <span style={{ color: "black", fontWeight: "500" }}>4.5</span>{" "}
              </div>
              <div style={{ color: "rgba(130, 130, 130, 1)" }} className="review-content">
                <span style={{ color: "black", fontWeight: "500" }}>92,123 </span>
                reviews
              </div>
            </div>

            <div>
              <div>
                <img src="./glassdoor-icon.svg" alt="profilePic" />
                <span style={{ color: "rgba(130, 130, 130, 1)", fontWeight: "600" }} className="reviewer-source-title">
                  {" "}
                  Glassdoor
                </span>
              </div>
              <div>
                <img src="./star-icon.svg" alt="star icon" className="star-icon" />
                <img src="./star-icon.svg" alt="star icon" className="star-icon" />
                <img src="./star-icon.svg" alt="star icon" className="star-icon" />
                <img src="./star-icon.svg" alt="star icon" className="star-icon" />
                <img src="./star-icon.svg" alt="star icon" className="star-icon" />
              </div>
              <div style={{ color: "rgba(130, 130, 130, 1)" }} className="review-content">
                Trusted Source <span style={{ color: "black", fontWeight: "500" }}>4.5</span>{" "}
              </div>
              <div style={{ color: "rgba(130, 130, 130, 1)" }} className="review-content">
                <span style={{ color: "black", fontWeight: "500" }}>92,123 </span>
                reviews
              </div>
            </div>

            <div>
              <div>
                <img src="./jd-icon.svg" alt="profilePic" />
                <span style={{ color: "rgba(130, 130, 130, 1)", fontWeight: "600" }} className="reviewer-source-title">
                  {" "}
                  JustDail
                </span>
              </div>
              <div>
                <img src="./star-icon.svg" alt="star icon" className="star-icon" />
                <img src="./star-icon.svg" alt="star icon" className="star-icon" />
                <img src="./star-icon.svg" alt="star icon" className="star-icon" />
                <img src="./star-icon.svg" alt="star icon" className="star-icon" />
                <img src="./star-icon.svg" alt="star icon" className="star-icon" />
              </div>
              <div style={{ color: "rgba(130, 130, 130, 1)" }} className="review-content">
                Trusted Source <span style={{ color: "black", fontWeight: "500" }}>4.5</span>{" "}
              </div>
              <div style={{ color: "rgba(130, 130, 130, 1)" }} className="review-content">
                <span style={{ color: "black", fontWeight: "500" }}>92,123 </span>
                reviews
              </div>
            </div>
          </div>
        </div>
      )}
    </main>
  ) : (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "80vh",
      }}
    >
      <div className="loading">
        <img src="./book-loader.gif" alt=" Loading . . .  " />
      </div>
    </div>
  );
}
